import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import type { SearchSchemaInput } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

export const tiersRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/tiers',
  component: lazyRouteComponent(() => import('./pages/TiersPage'), 'TiersPage'),
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
    ...validateListSearch(search),
    includeArchived:
      search.includeArchived === true || search.includeArchived === 'true' ? true : undefined,
  }),
});

export const tiersRoutes = [tiersRoute];
